module.exports = __webpack_public_path__ + "img/acinterviewprocess.bd065122.svg";